const tag = {
    types: [
        // NOTE: remove on live
        '2pl',
        '2pmi',
        '2pmx',
        '2ps',
        '2psm',
        'cat',
        'ct',
        'eenc',
        'ejbs',
        'eltc',
        'eltcr',
        'elts',
        'emps',
        'emts',
        'fb',
        'ft',
        'fto',
        'jlt',
        'lt',
        'mb',
        'ml',
        'mmi',
        'ms',
        'mt',
        'mtt',
        'mxm',
        'of1',
        'of2',
        'of3',
        'of4',
        'tt',
    ],
};
const TagReducer = function(state = tag, action) {
    switch (action.type) {
        case 'CHANGE_TAG_TYPE': {
            // NOTE: remove in prod
            return {
                ...state,
                group: action.value,
            };
        }
        case 'SET_TAG_TYPE': {
            return {
                ...state,
                type: action.data,
            };
        }
        case 'SET_TAG_DETAILS': {
            return {
                ...state,
                ...action.data,
            };
        }
        default: {
            return state;
        }
    }
};

export default TagReducer;
